<template>
  <!-- 通用上门多条缴费开票信息 -->
  <div class="alBindBat">
    <van-nav-bar title="开票信息" left-arrow fixed @click-left="onClickLeft" />
    <div class="con_top">
      统一修改已选中数据开票信息
    </div>
    <div class="content" :class="tKeys.length > 6 ? 'abs' : ''">
      <!-- 12312312 -->
      <van-form ref="formPhone">
        <div class="phoneBox">
          <van-field
            v-for="(it, index) in tKeys"
            :key="index"
            v-model="currentValue[it]"
            :label="ticketList[it]"
            :disabled="currentValue.isConfirm == '1'"
            :placeholder="
              currentValue.isConfirm == '1' ? '' : '请输入' + ticketList[it]
            "
            input-align="right"
          />
          <div>
            <van-field
              readonly
              right-icon="arrow"
              v-model="currentValue.payerTypeName"
              @click="openPick"
              label="开票类型"
              input-align="right"
              placeholder="请选择开票类型"
            />
            <!-- <img src="../assets/img/bjicon.png" alt="" /> -->
          </div>
          <!-- <img src="../assets/img/bjicon.png" alt="" /> -->
        </div>
      </van-form>
      <div class="bottom" :class="tKeys.length > 6||showAndr ? 'abs' : ''">
        <div class="notice_info">
          提示：<br />
          (1) 确定修改：统一修改开票信息，继续缴费。
          <br />(2) 不修改：保留原开票信息不变，继续缴费。
        </div>
        <van-button @click="saveBill" block class="confirm" round type="info"
          >确定修改
        </van-button>
        <van-button @click="conBill" block class="cancle" round type="info"
          >不修改
        </van-button>
      </div>
    </div>
    <div class="codedialog">
      <van-popup
        v-model="QrcodeDialogVisible"
        round
        :close-on-click-overlay="false"
        :get-container="getContainer"
      >
        <div class="wrap">
          <div class="content">
            <!-- <div class="circle"></div> -->
            <div class="ti">
              <div class="tiLogo">
                <div
                  id="qrCode"
                  ref="qrCodeDiv1"
                  style="margin: 0 auto; width: 154px"
                ></div>
              </div>
            </div>
            <div class="qrCenter">支持支付宝、微信扫码</div>
            <div class="qrContent">
              <div class="qc_top">
                <span>缴款人</span>
                <span>{{ paymentUnit }}</span>
              </div>
              <div class="qc_bot">
                <span>缴款金额</span>
                <span class="qc_money">¥{{ paymentTotal }}</span>
              </div>
            </div>
            <div class="butarea">
              <van-button
                @click="goBack"
                block
                class="confirm"
                round
                type="info"
                >确认
                <img
                  class="blueSha"
                  src="../../assets/img/blueshadow.png"
                  alt=""
                />
              </van-button>
            </div>
          </div>
        </div>
      </van-popup>
    </div>
    <ErrDialog :show="showErr" :notice="errCon" @close="closeErr"></ErrDialog>
    <ErrorNotice
      :show="showError"
      :notice="noticeE"
      :reason="reason"
      :errMsg="errMsg"
      @close="getClose"
    ></ErrorNotice>
    <van-popup v-model="showType" position="bottom" title="缴款人类型">
      <van-picker
        ref="van_picker"
        v-if="showType"
        title="开票类型"
        show-toolbar
        :columns="options"
        value-key="label"
        @confirm="onConfirm"
        :default-index="defaultIndex"
        @cancel="showType = false"
      />
    </van-popup>
  </div>
</template>

<script>
import Foot from "@/components/foot";
import { judgeVde } from "@/utils/publicJudge";
import { Toast } from "vant";
import ErrDialog from "@/components/dialog/errorNotice";
import { Notify } from "vant";
import ErrorNotice from "./components/errorNotice.vue";
import QRCode from "qrcodejs2";

export default {
  data() {
    return {
      showAndr:false,
      defaultIndex: 0,
      options: [],
      showType: false,
      paymentTotal: 0,
      paymentUnit: "",
      showErr: false,
      noticeE: "",
      reason: "",
      errMsg: "",
      showError: false,
      errCon: "",
      currentValue: {},
      deptId: "",
      dataType: "",
      uId: "",
      ticketList: {},
      tKeys: [], // 保存票据信息的keys
      paramsObj: {},
      QrcodeDialogVisible: false,
      screenHeight: document.documentElement.clientHeight, // 当前高度
      originHeight: document.documentElement.clientHeight, //默认高度，用作比较
    };
  },
  components: {
    ErrDialog,
    ErrorNotice
  },
  watch: {
    $route: {
      handler(nv, ov) {
        // console.log(nv);
        // if (nv.path != "/bussiess/payBillInfo") {
        //   localStorage.removeItem("currentValue");
        // }
      },
      immediate: true,
      deep: true
    },
    screenHeight(val) {
      if (this.originHeight - val > 60) {
        // Dialog.alert({
        //   title: '标题1',
        //   message: this.originHeight,
        // }).then(() => {
        //   // on close
        // });
        //这里以防万一改了下判断形式，当屏幕高度减少了60px以上时才隐藏footer
        this.showAndr = true;
      } else {
        // Dialog.alert({
        //   title: '标题2',
        //   message: '弹窗内容',
        // }).then(() => {
        //   // on close
        // });
        //这里以防万一改了下判断形式，当屏幕高度减少了60px以上时才隐藏footer
        this.showAndr = false;
      }
    }
  },
  mounted(){
    window.onresize = () => {
      return (() => {
        window.fullHeight = document.documentElement.clientHeight;
        this.screenHeight = window.fullHeight;
      })();
    };
  },
  created() {
    this.deptId = this.$route.query.deptId ? this.$route.query.deptId : "";
    this.dataType = this.$route.query.dataType
      ? this.$route.query.dataType
      : "";
    if (localStorage.getItem("currentValue")) {
      this.currentValue = JSON.parse(localStorage.getItem("currentValue"));
    }
    if (localStorage.getItem("currentValueCash")) {
      this.currentValue = JSON.parse(localStorage.getItem("currentValueCash"));
    }
    if (localStorage.getItem("currentValueQr")) {
      this.currentValue = JSON.parse(localStorage.getItem("currentValueQr"));
    }
    this.$set(this.currentValue, "uId", this.$route.query.uId);

    this.$set(
      this.currentValue,
      "payerTypeName",
      this.currentValue.payerType == 2 ? "单位" : "个人"
    );
    this.paramsObj = JSON.parse(localStorage.getItem("paramsObj"));
    // console.log(this.paramsObj)
    // 选择的checkArr
    this.getTicketMess();
    // 获取开票类型
    this.getPayerType();
  },
  methods: {
    getPayerType() {
      // sys_payer_type  数据字典
      this.request({
        url: "/system/dictionary/listDictData/sys_payer_type",
        method: "get"
      }).then(res => {
        if (res.data.code == 1000) {
          this.options = [];
          res.data.result.forEach(item => {
            this.options.push(item);
          });
        }
      });
    },
    onConfirm(val) {
      this.currentValue.payerType = val.value;
      this.currentValue.payerTypeName = val.label;
      this.showType = false;
    },
    openPick() {
      if (this.currentValue.payerType) {
        this.defaultIndex = this.options.findIndex(val => {
          return val.value == this.currentValue.payerType;
        });
      } else {
        this.defaultIndex = 0;
      }
      this.showType = true;
      // 使用setIndexes方法设置选中项
      if (this.$refs.van_picker) {
        console.log(this.$refs.van_picker);
        this.$nextTick(() => {
          this.$refs.van_picker.setIndexes([this.defaultIndex]);
        });
      }
    },
    getContainer() {
      return document.querySelector(".codedialog");
    },
    getDefault() {
      this.request({
        url: "/mobile/getDefaultData",
        method: "get",
        params: {
          noticeNo: this.currentValue.noticeNo,
          flag: this.currentValue.sysType
        }
      }).then(res => {
        if (res.data.code == 1000) {
          if (res.data.result) {
            this.currentValue.billName = this.currentValue.billName
              ? this.currentValue.billName
              : res.data.result.paymentUnit;
            this.currentValue.billSocialCreditCode = this.currentValue
              .billSocialCreditCode
              ? this.currentValue.billSocialCreditCode
              : res.data.result.idCard;
          }
        } else {
          this.$CDialog({
            confirmBtnText: "确认",
            title: "提示",
            status: "2",
            textSize: 16,
            message: res.data.message
          }).then(res => {});
        }
      });
    },
    // 页面点击返回
    onClickLeft: function() {
      this.$router.go(-1);
    },
    // 改成批量修改开票信息
    saveBill() {
      if (this.currentValue.isConfirm == "1") {
        this.$router.go(-1);
      } else {
        if (!this.currentValue.billName) {
          this.$CDialog({
            confirmBtnText: "确认", //按钮文字
            title: "提示", //title提示文字
            message: "开票名称不能为空", //弹窗内容
            status: "2", //显示哪种图   1 为绿色   2为蓝色
            textSize: 16
          }).then(res => {
            // this.usepay = false;
          });
          return;
        }
        let data = [];
        let defaultType = "";
        if (this.options && this.options.length > 0) {
          defaultType = this.options[0].value;
        }
        let checkArr = JSON.parse(localStorage.getItem("tcList"));
        checkArr.forEach(item => {
          this.tKeys.forEach(it => {
            item[it] = this.currentValue[it];
          });
          item.payerType = this.currentValue.payerType || defaultType;
          item.isGeneral = "1";
          data.push(item);
        });
        this.request({
          url: "/mobile/updateH5BizDateBill",
          method: "post",
          data: data
        }).then(res => {
          if (res.data.code == 1000) {
            // 判断是否是强制弹框
            if (localStorage.getItem("forceCashUpd") == "1") {
              // 判断如果是二维码缴费，则进行生成二维码的操作
              let selectRow = JSON.parse(localStorage.getItem("paramsObj"));
              delete this.paramsObj.selectR;
              // 继续进行现金缴费
              this.request({
                url: "/pay/cashPay",
                method: "post",
                data: this.paramsObj
              }).then(res => {
                Toast.clear();
                if (res.data.code == 1000) {
                  if (
                    res.data.result.count > 0 &&
                    res.data.result.errorCount == 0
                  ) {
                    const bill = {
                      bizId: selectRow.uId,
                      noticeNo: selectRow.noticeNo,
                      sysType: selectRow.sysType,
                      billInterfaceType: selectRow.billInterfaceType
                    };
                    this.request({
                      baseURL: process.env.VUE_APP_PAY_URL,
                      url: "/pay/showETicket",
                      method: "post",
                      data: bill
                    }).then(res1 => {
                      if (res1.data.code == 1000) {
                        Notify({
                          type: "success",
                          message: "现金缴费成功并成功开具电子票"
                        });
                        this.$router.go(-1);
                      } else {
                        //  this.dialogAlert('提示',"现金缴费成功，开具电子票失败，错误信息：" +res1.data.message)

                        let msgArr = res1.data.message.split("，");
                        this.showError = true;
                        this.noticeE = "现金缴费成功，开具电子票失败";
                        this.reason = msgArr[1];
                        this.errMsg = "错误信息：" + msgArr[0];
                        // this.$CDialog({
                        //   confirmBtnText: "确认",  //按钮文字
                        //   title: "提示",    //title提示文字
                        //   message: "现金缴费成功，开具电子票失败，错误信息"+res1.data.message,   //弹窗内容
                        //   status: "2",    //显示哪种图   1 为绿色   2为蓝色
                        //   textSize:16
                        // }).then(res=>{

                        // });
                      }
                      // this.checkArr = [];
                      // this.showHistory = true;
                      // this.usepay = false;
                      // this.checkedAll = false;
                      // this.afAction = "2";
                      // this.dataList.forEach((val, index) => {
                      //   this.$set(val, "checked", false);
                      // });
                      // this.payAmtNotice = "0.00";
                    });
                  } else {
                    // Dialog.alert({
                    //   title: "提示",
                    //   message:res.data.result.errorList[0],
                    //   confirmButtonColor:'#2D53EB',
                    //   getContainer:'.payListBox'
                    // }).then(() => {
                    //    this.usepay = false;
                    // });
                    let err = "";
                    res.data.result.errorList.forEach(item => {
                      err += item + "  <br />";
                    });
                    this.$CDialog({
                      confirmBtnText: "确认", //按钮文字
                      title: "提示", //title提示文字
                      message: err, //弹窗内容
                      status: "2", //显示哪种图   1 为绿色   2为蓝色
                      textSize: 16
                    }).then(res => {
                      // this.usepay = false;
                      this.$router.go(-1);
                    });
                  }
                } else {
                  // this.dialogAlert('提示',res.data.message)
                  this.$CDialog({
                    confirmBtnText: "确认", //按钮文字
                    title: "提示", //title提示文字
                    message: res.data.message, //弹窗内容
                    status: "2", //显示哪种图   1 为绿色   2为蓝色
                    textSize: 16
                  }).then(res => {
                    // this.usepay = false;
                  });
                }
              });
            } else {
              this.$CDialog({
                confirmBtnText: "确认", //按钮文字
                title: "提示", //title提示文字
                message: res.data.message, //弹窗内容
                status: "2", //显示哪种图   1 为绿色   2为蓝色
                textSize: 16
              }).then(res => {
                this.$router.go(-1);
              });
            }
            this.$emit("reget");
          } else {
            this.$CDialog({
              confirmBtnText: "确认", //按钮文字
              title: "提示", //title提示文字
              message: res.data.message, //弹窗内容
              status: "2", //显示哪种图   1 为绿色   2为蓝色
              textSize: 16
            }).then(res => {});
          }
        });
      }
    },
    // 不改开票信息继续缴费
    conBill() {
      let selectRow = JSON.parse(localStorage.getItem("paramsObj"));
      delete this.paramsObj.selectR;
      // 继续进行现金缴费
      this.request({
        url: "/pay/cashPay",
        method: "post",
        data: this.paramsObj
      }).then(res => {
        Toast.clear();
        if (res.data.code == 1000) {
          if (res.data.result.count > 0 && res.data.result.errorCount == 0) {
            const bill = {
              bizId: selectRow.uId,
              noticeNo: selectRow.noticeNo,
              sysType: selectRow.sysType,
              billInterfaceType: selectRow.billInterfaceType
            };
            this.request({
              baseURL: process.env.VUE_APP_PAY_URL,
              url: "/pay/showETicket",
              method: "post",
              data: bill
            }).then(res1 => {
              if (res1.data.code == 1000) {
                Notify({
                  type: "success",
                  message: "现金缴费成功并成功开具电子票"
                });
                this.$router.go(-1);
              } else {
                //  this.dialogAlert('提示',"现金缴费成功，开具电子票失败，错误信息：" +res1.data.message)

                let msgArr = res1.data.message.split("，");
                this.showError = true;
                this.noticeE = "现金缴费成功，开具电子票失败";
                this.reason = msgArr[1];
                this.errMsg = "错误信息：" + msgArr[0];
                // this.$CDialog({
                //   confirmBtnText: "确认",  //按钮文字
                //   title: "提示",    //title提示文字
                //   message: "现金缴费成功，开具电子票失败，错误信息"+res1.data.message,   //弹窗内容
                //   status: "2",    //显示哪种图   1 为绿色   2为蓝色
                //   textSize:16
                // }).then(res=>{

                // });
              }
              // this.checkArr = [];
              // this.showHistory = true;
              // this.usepay = false;
              // this.checkedAll = false;
              // this.afAction = "2";
              // this.dataList.forEach((val, index) => {
              //   this.$set(val, "checked", false);
              // });
              // this.payAmtNotice = "0.00";
            });
          } else {
            // Dialog.alert({
            //   title: "提示",
            //   message:res.data.result.errorList[0],
            //   confirmButtonColor:'#2D53EB',
            //   getContainer:'.payListBox'
            // }).then(() => {
            //    this.usepay = false;
            // });
            let err = "";
            res.data.result.errorList.forEach(item => {
              err += item + "  <br />";
            });
            this.$CDialog({
              confirmBtnText: "确认", //按钮文字
              title: "提示", //title提示文字
              message: err, //弹窗内容
              status: "2", //显示哪种图   1 为绿色   2为蓝色
              textSize: 16
            }).then(res => {
              // this.usepay = false;
              this.$router.go(-1);
            });
          }
        } else {
          // this.dialogAlert('提示',res.data.message)
          this.$CDialog({
            confirmBtnText: "确认", //按钮文字
            title: "提示", //title提示文字
            message: res.data.message, //弹窗内容
            status: "2", //显示哪种图   1 为绿色   2为蓝色
            textSize: 16
          }).then(res => {
            // this.usepay = false;
          });
        }
      });
    },
    initPayType(data) {
      return this.request({
        url: "/sysFunConfig/getSysFunConfig",
        method: "get",
        params: data
      }).then(res => {
        if (res.data.code == 1000) {
          return res.data.result;
        }
      });
    },
    goBack() {
      this.QrcodeDialogVisible = false;
      window.localStorage.removeItem("forceCashUpd");
      window.localStorage.removeItem("currentValue");
      window.localStorage.removeItem("currentValueCash");
      window.localStorage.removeItem("currentValueQr");
      window.localStorage.removeItem("paramsObj");
      window.localStorage.removeItem("qrCode");

      this.$router.go(-1);
    },
    getQrcode(data) {
      Toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0
      });
      this.initPayType({ deptId: this.deptId, type: 22 }).then(res => {
        if (res.value == "0") {
          this.request({
            url: "/pay/getQrcodeUrl",
            method: "post",
            data: data
          }).then(res => {
            Toast.clear();
            if (res.data.code === 1000) {
              // 获取返回的二维码连接地址
              this.QrcodeDialogVisible = true;
              setTimeout(() => {
                document.getElementById("qrCode").innerHTML = "";
                new QRCode(this.$refs.qrCodeDiv1, {
                  text: res.data.result.qrCodeUrl,
                  width: 160,
                  height: 160,
                  colorDark: "#333333", // 二维码颜色
                  colorLight: "#ffffff", // 二维码背景色
                  correctLevel: QRCode.CorrectLevel.L // 容错率，L/M/H
                });
              }, 100);
              // this.showHistory = true;
              setTimeout(() => {
                $(".codedialog .van-dialog__header").css({
                  background: "#2D53EB",
                  color: "#fff"
                });
              });
            } else {
              //  this.dialogAlert('提示',res.data.message)
              this.$CDialog({
                confirmBtnText: "确认",
                title: "提示",
                message: res.data.message,
                status: "2",
                textSize: 16
              }).then(res => {});
            }
          });
        } else if (res.value == "1") {
          let info = {
            deptId: this.deptId,
            bizId: data.bizId,
            sysType: "2",
            operationType: "1" //创建二维码
          };
          this.getPlaceOrder(info).then(result => {
            Toast.clear();
            if (result == false) return;
            // 获取返回的二维码连接地址
            this.QrcodeDialogVisible = true;
            setTimeout(() => {
              document.getElementById("qrCode").innerHTML = "";
              new QRCode(this.$refs.qrCodeDiv1, {
                text: result.extraInfo,
                width: 290,
                height: 290,
                colorDark: "#333333", // 二维码颜色
                colorLight: "#ffffff", // 二维码背景色
                correctLevel: QRCode.CorrectLevel.L // 容错率，L/M/H
              });
            }, 100);
          });
        }
      });
    },
    getClose() {
      this.showError = false;
      this.$router.go(-1);
      //关闭提示之后查询
    },
    closeErr() {
      this.showErr = false;
    },
    getTicketMess() {
      this.request({
        url: "/business/getBillField",
        method: "post",
        params: {
          dataType: this.dataType,
          deptId: this.deptId,
          type: localStorage.getItem("forceCashUpd") ? "1" : ""
        }
      }).then(res => {
        if (res.data.code == 1000) {
          if (res.data.result) {
            this.ticketList = res.data.result;
            if (this.tKeys.length > 0) {
              this.tKeys.forEach(it => {
                if (this.currentValue[it] == undefined && it != "uId") {
                  delete this.currentValue[it];
                }
              });
            }
            this.tKeys = Object.keys(this.ticketList);
            let flag1 = true;
            let rows = [];
            // console.log(this.$route.query.dList)
            if (localStorage.getItem("tcList")) {
              let objParams = JSON.parse(localStorage.getItem("tcList"));
              rows = objParams;
            }
            // paramsObj  判断选中的数据是否开票信息一致
            // if (rows.length > 0) {
            //   this.tKeys.forEach(it => {
            //     let flag = rows.every(item => {
            //       return item[it] && item[it] == rows[0][it];
            //     });

            //     if (!flag) {
            //       flag1 = false;
            //     }
            //   });
            //   console.log(flag1)
            //   if (flag1) {
            //     // for (var i in res.data.result) {
            //     //   if (!this.currentValue[i] && i != "uId") {
            //     //     this.$set(this.currentValue, i, "");
            //     //   }
            //     // }
            //     console.log(123)
            //     // 一致，默认填充就行
            //     if (localStorage.getItem("forceCashUpd")) {
            //       this.getDefault();
            //     }
            //   } else {
            //     // 不一致就置空
            //     this.tKeys.forEach(it => {
            //       this.$set(this.currentValue, it, "");
            //     });
            //   }
            // }
            let empty = false;
            if (rows.length > 0) {
              this.tKeys.forEach(it => {
                let flag = rows.every(item => {
                  return item[it] && item[it] == rows[0][it];
                });
                if (!flag) {
                  flag1 = false;
                }

                // 判断是否全部为空, 全都为空就是true
                empty = rows.every(item => {
                  return !item[it];
                });
              });
              if (flag1 && !empty) {
                // 一致，默认填充就行，
                if (localStorage.getItem("forceCashUpd")) {
                  this.getDefault();
                }
              } else {
                let sameFlag = true;
                if (empty) {
                  sameFlag = rows.every(item => {
                    console.log(
                      item.idCard == rows[0].idCard &&
                        item.paymentUnit == rows[0].paymentUnit
                    );
                    return (
                      item.idCard == rows[0].idCard &&
                      item.paymentUnit == rows[0].paymentUnit
                    );
                  });
                  if (sameFlag) {
                    this.getDefault();
                  } else {
                    this.tKeys.forEach(it => {
                      this.$set(this.currentValue, it, "");
                    });
                  }
                } else {
                  this.tKeys.forEach(it => {
                    this.$set(this.currentValue, it, "");
                  });
                }
              }
            }
            this.show = true;
          } else {
            this.showErr = true;
            this.errCon = "票据信息为空";
          }
        } else {
          if (!res.data.errorMessage) {
            // Dialog.alert({
            //   title: "提示",
            //   message: res.data.message,
            // }).then(() => {});
            this.showErr = true;
            this.errCon = res.data.message;
          }
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.alBindBat {
  padding-top: 66px;
  padding-left: 15px;
  padding-right: 15px;
  height: 100vh;
  box-sizing: border-box;

  ::v-deep .van-icon {
    color: #666;
    text-align: center;
  }
  ::v-deep .van-nav-bar__title {
    font-family: PingFangSC-Semibold;
    font-size: 17px;
    color: #333333;
    letter-spacing: 0;
    text-align: center;
    font-weight: 600;
  }
  .content {
    margin: 0px auto;
    width: 345px;
    background: #ffffff;
    border-radius: 10px 10px 0px 0px;
    height: calc(100vh - 46px - 44px - 10px - 20px);
    // padding-top: 14px;
    box-sizing: border-box;
    position: relative;
    padding-bottom: 20px;
    ::v-deep .van-form{
      border-radius: 10px 10px 0px 0px;
    }
    .billBox {
      position: relative;
      border-bottom: 1px solid #eee;

      font-size: 14px;
      color: #464a4c;
      letter-spacing: 0;
      font-weight: 400;
      > img {
        width: 14px;
        position: absolute;
        top: 16px;
        right: 10px;
      }
      ::v-deep .van-field__right-icon {
        color: rgba(0, 0, 0, 0.3);
      }
    }
    .phoneBox {
      border-radius: 10px 10px 0px 0px;
      ::v-deep .van-cell:nth-of-type(1){
       border-radius: 10px 10px 0px 0px;
      }
      ::v-deep .van-field__label {

        font-size: 16px;
        color: #464a4c;
        letter-spacing: 0;
        font-weight: 400;
        width: 114px;
      }
      ::v-deep .van-field__control {

        font-size: 16px;
        color: #464a4c;
        letter-spacing: 0;
        text-align: right;
        font-weight: 500;
      }
      ::v-deep .van-field__control::-webkit-input-placeholder {

        font-size: 16px;
        color: #cccccc;
        letter-spacing: 0;
        text-align: right;
        font-weight: 400;
      }
    }
    .bottom {
      // height: 33%;
      position: absolute;
      bottom: 20px;
      left: 50%;
      transform: translateX(-50%);
      .notice_info {
        line-height: 20px;
        width: 305px;
        // height: 60px;
        margin: 0 auto;

        font-size: 14px;
        color: #cccccc;
        letter-spacing: 0;
        font-weight: 400;
        margin-bottom: 40px;
      }
    }
    .bottom.abs {
      position: static;
      // bottom: 10px;
      margin: 50px auto;
      // left: 50%;
      transform: translateX(0%);
      margin-bottom: 20px;
      margin-top: 50px;
      .notice_info {
        line-height: 20px;
        width: 305px;
        // height: 60px;
        margin: 0 auto;

        font-size: 14px;
        color: #cccccc;
        letter-spacing: 0;
        font-weight: 400;
        margin-bottom: 40px;
      }
    }
  }
  .content.abs {
    height: auto;
    padding-bottom: 20px;
    .bottom.abs {
      position: static;
      // bottom: 10px;
      margin: 50px auto;
      // left: 50%;
      transform: translateX(0%);
      margin-bottom: 0px;

      .notice_info {
        line-height: 20px;
        width: 305px;
        // height: 60px;
        margin: 0 auto;

        font-size: 14px;
        color: #cccccc;
        letter-spacing: 0;
        font-weight: 400;
        margin-bottom: 40px;
      }
    }
  }
}
.confirm {
  width: 305px;
  height: 44px;
  color: #fff !important;
  background-image: linear-gradient(-45deg, #54adfb 0%, #297bf4 100%);
  border-radius: 22px;
  margin: 0 auto;

  font-size: 18px;
  color: #ffffff;
  letter-spacing: 0;
  font-weight: 700;
  position: relative;
  margin-bottom: 10px;
  border: none;
  .blueSha {
    width: 286px;
    height: 34px;
    position: absolute;
    left: 50%;
    top: 68%;
    transform: translateX(-50%);
  }
}
.cancle {
  width: 305px;
  height: 44px;
  background: #fff !important;
  margin: 0 auto;
  border: 1px solid rgba(32, 143, 255, 1);
  border-radius: 22px;

  font-size: 18px;
  text-align: center;
  color: #ffffff;
  position: relative;

  font-size: 18px;
  color: #208fff;
  letter-spacing: 0;
  font-weight: 400;
}
.codedialog {
  ::v-deep .van-popup {
    background-color: transparent;
  }
}
.wrap {
  padding-top: 50px;
  min-height: 334px;
}
.ti {
  position: relative;
  // text-align: center;
  // position: absolute;
  // top: 4%;
  // left: 50%;
  // z-index: 1001;
  // width: 86%;
  // transform: translateX(-50%);
  font-size: 16px;
  // color: #fff;
  padding: 18px 0px;
  border-radius: 8px 8px 0px 0px;
  // background: url("../assets/img/zfnotice.png");
  // background-size: cover;
  ::v-deep .van-divider {
    margin: 10px 0px !important;
    background: rgb(235, 235, 235) !important;
  }
  #qrCode {
  }
  .tiLogo {
    position: absolute;
    width: 310px;
    height: 205px;
    left: 50%;
    top: -132%;
    padding-top: 20px;
    box-sizing: border-box;
    transform: translateX(-50%);
    z-index: 9999;
    background: url("../../assets/img/tyQrcode.png") no-repeat;
    background-size: 100% 100%;
  }
}
.con_top {
  margin: 0 auto;
  width: 344px;
  height: 44px;
  background: #ffffff;
  border-radius: 10px;
  // width: 180px;
  // height: 20px;
  text-align: center;

  font-size: 14px;
  line-height: 44px;
  color: #f46c6c;
  letter-spacing: 0;
  margin-bottom: 10px;
  font-weight: 400;
}
.content {
  width: 344px;

  .qrContent {
    width: 304px;
    min-height: 89px;
    margin: 0 auto;
    .qc_top {
      // height: 44px;
      border-bottom: 1px solid #eeeeee;
      display: flex;
      justify-content: space-between;
      padding: 12px 14px;
      box-sizing: border-box;

      font-size: 14px;
      color: #464a4c;
      letter-spacing: 0;
      font-weight: 400;
      > span:nth-of-type(2) {
        width: 210px;
        word-break: break-all;
      }
    }
    .qc_bot {
      // height: 44px;
      display: flex;
      justify-content: space-between;
      padding: 12px 14px;
      box-sizing: border-box;

      font-size: 14px;
      color: #464a4c;
      letter-spacing: 0;
      font-weight: 400;
      .qc_money {

        font-size: 14px;
        color: #f46c6c;
        letter-spacing: 0;
        text-align: right;
        font-weight: 500;
      }
    }
  }
  .qrCenter {
    background: #f1f1f1;
    border-radius: 10px;
    width: 304px;
    height: 44px;
    margin: 0 auto;
    margin-top: 140px;

    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #464a4c;
    letter-spacing: 0;
    font-weight: 400;
  }
  // border-radius: 8px;
  // position: absolute;
  // top: 50%;
  // left: 50%;
  // width: 72%;
  // max-height: 75%;
  // transform: translate(-50%, -50%);
  // background: #fff;
  // text-align: left;
  // line-height: 24px;
  // ::v-deep .van-divider {
  //   background: rgb(235, 235, 235) !important;
  // }
  height: calc(100vh - 46px - 44px - 10px);
  background: #fff;
  border-radius: 0.42667rem;
}
</style>
